import {
  View,
  Text,
  Modal,
  TouchableOpacity,
  ScrollView,
  StyleSheet,
} from "react-native";
import React, { useState } from "react";
import Ionicons from "@expo/vector-icons/Ionicons";
import { useStateContext } from "../lib/context";
import { useNavigation } from "@react-navigation/native";
import { signOut } from "firebase/auth";
import { auth } from "../firebase.js";

const MenuItem = ({ icon, label, onPress }) => (
  <TouchableOpacity style={s.item} onPress={onPress} activeOpacity={0.7}>
    <Ionicons name={icon} size={20} color="#080680" style={s.itemIcon} />
    <Text style={s.itemLabel}>{label}</Text>
    <Ionicons name="chevron-forward-outline" size={16} color="#bbb" />
  </TouchableOpacity>
);

const SectionLabel = ({ text }) => (
  <Text style={s.sectionLabel}>{text}</Text>
);

const SideMenu = () => {
  const [visible, setVisible] = useState(false);
  const { currentUser, admin, isViajante } = useStateContext();
  const navigation = useNavigation();

  const go = (screen) => {
    setVisible(false);
    navigation.navigate(screen);
  };

  const logOut = () => {
    setVisible(false);
    signOut(auth).then(() => navigation.replace("Login"));
  };

  const displayUser = currentUser?.replace("@mail.com", "") ?? "";

  return (
    <>
      <Ionicons
        name="menu-outline"
        size={32}
        color="white"
        onPress={() => setVisible(true)}
      />

      <Modal
        visible={visible}
        transparent
        animationType="fade"
        onRequestClose={() => setVisible(false)}
      >
        <View style={s.overlay}>
          <TouchableOpacity
            style={s.backdrop}
            onPress={() => setVisible(false)}
            activeOpacity={1}
          />
          <View style={s.drawer}>
            {/* Header */}
            <View style={s.header}>
              <View style={s.headerRow}>
                <View style={s.logoCircle}>
                  <Text style={s.logoText}>ERO</Text>
                </View>
                <TouchableOpacity onPress={() => setVisible(false)} style={s.closeBtn}>
                  <Ionicons name="close-outline" size={26} color="#666" />
                </TouchableOpacity>
              </View>
              <Text style={s.userName}>{displayUser}</Text>
              {admin && (
                <View style={s.adminBadge}>
                  <Text style={s.adminBadgeText}>Administrador</Text>
                </View>
              )}
            </View>

            {/* Nav items */}
            <ScrollView style={s.scroll} showsVerticalScrollIndicator={false}>
              <SectionLabel text="MI CUENTA" />
              <MenuItem
                icon="receipt-outline"
                label="Mis Pedidos"
                onPress={() => go(isViajante ? "OrdersViajantes" : "Orders")}
              />

              {admin && (
                <>
                  <SectionLabel text="ADMINISTRACIÓN" />
                  <MenuItem
                    icon="list-outline"
                    label="Todos los Pedidos"
                    onPress={() => go("Todos")}
                  />
                  <MenuItem
                    icon="checkmark-done-outline"
                    label="Gestionar Pedidos"
                    onPress={() => go("AdminOrders")}
                  />
                  <MenuItem
                    icon="settings-outline"
                    label="Configuración Admin"
                    onPress={() => go("Admin")}
                  />
                  <MenuItem
                    icon="people-outline"
                    label="Viajantes"
                    onPress={() => go("Viajantes")}
                  />
                  <MenuItem
                    icon="person-outline"
                    label="Consulta de Cliente"
                    onPress={() => go("AdminClientLookup")}
                  />
                  <MenuItem
                    icon="images-outline"
                    label="Imágenes de Productos"
                    onPress={() => go("AdminImageUpload")}
                  />
                </>
              )}
            </ScrollView>

            {/* Footer */}
            <View style={s.footer}>
              {isViajante ? (
                <TouchableOpacity style={s.changeUserBtn} onPress={() => go("SeleccionarCliente")} activeOpacity={0.8}>
                  <Ionicons name="people-outline" size={20} color="#fff" />
                  <Text style={s.logoutText}>Cambiar Cliente</Text>
                </TouchableOpacity>
              ) : (
                <TouchableOpacity style={s.logoutBtn} onPress={logOut} activeOpacity={0.8}>
                  <Ionicons name="log-out-outline" size={20} color="#fff" />
                  <Text style={s.logoutText}>Cerrar Sesión</Text>
                </TouchableOpacity>
              )}
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
};

const DRAWER_WIDTH = 300;

const s = StyleSheet.create({
  overlay: {
    flex: 1,
    flexDirection: "row",
  },
  backdrop: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.45)",
  },
  drawer: {
    width: DRAWER_WIDTH,
    backgroundColor: "#fff",
    flexDirection: "column",
    shadowColor: "#000",
    shadowOffset: { width: -2, height: 0 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 10,
  },
  header: {
    backgroundColor: "#080680",
    padding: 20,
    paddingTop: 24,
  },
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  logoCircle: {
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: "rgba(255,255,255,0.2)",
    alignItems: "center",
    justifyContent: "center",
  },
  logoText: {
    color: "#fff",
    fontWeight: "700",
    fontSize: 14,
    letterSpacing: 1,
  },
  closeBtn: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: "rgba(255,255,255,0.15)",
    alignItems: "center",
    justifyContent: "center",
  },
  userName: {
    color: "rgba(255,255,255,0.9)",
    fontSize: 15,
    fontWeight: "600",
  },
  adminBadge: {
    marginTop: 6,
    alignSelf: "flex-start",
    backgroundColor: "rgba(255,255,255,0.2)",
    borderRadius: 20,
    paddingHorizontal: 10,
    paddingVertical: 3,
  },
  adminBadgeText: {
    color: "#fff",
    fontSize: 11,
    fontWeight: "600",
    letterSpacing: 0.5,
  },
  scroll: {
    flex: 1,
    paddingTop: 8,
  },
  sectionLabel: {
    fontSize: 11,
    fontWeight: "700",
    color: "#aaa",
    letterSpacing: 1,
    marginTop: 20,
    marginBottom: 4,
    paddingHorizontal: 20,
  },
  item: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: "#f0f0f0",
  },
  itemIcon: {
    marginRight: 14,
  },
  itemLabel: {
    flex: 1,
    fontSize: 15,
    color: "#222",
    fontWeight: "500",
  },
  footer: {
    padding: 20,
    borderTopWidth: 1,
    borderTopColor: "#f0f0f0",
  },
  logoutBtn: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#c0392b",
    borderRadius: 10,
    paddingVertical: 12,
    gap: 8,
  },
  changeUserBtn: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#080680",
    borderRadius: 10,
    paddingVertical: 12,
    gap: 8,
  },
  logoutText: {
    color: "#fff",
    fontSize: 15,
    fontWeight: "600",
  },
});

export default SideMenu;
